export const GRAMS_IN_KILOGRAM = 1000;
export const KILOGRAMS_IN_TON = 1000;
